<!-- svelte-ignore a11y-missing-attribute -->
<Secure>
  {#if $appState.user?.isAdmin}
  <div class="level has-background-primary p-2">
    <div class="level-item">
      <p>
      You are acting as the charity <b>{$appState.charity?.name}</b>. <a on:click={adminView}>Switch to admin view</a> or <a on:click={endAccess}>Stop acting as the charity</a>
      </p>
    </div>
  </div>
  {/if}
  <Nav on:logoff={() => logoff()} />
  <div class="section">
    <div class="container">
      {#if $appState.charity && !tearingDown}
        {#if $uiState.activeModal}
          <svelte:component
            this={$uiState.activeModal.component}
            {...$uiState.activeModal.props}
          />
        {/if}

        {#if !$appState.auth_user?.emailVerified}
          <VerifyEmailMessage />
        {:else if !$appState.charity?.isOwnershipVerified}
          <AwaitingAdditionalVerificationMessage />
        {/if}

        <slot />
      {/if}
    </div>
  </div>
</Secure>

<script lang="ts">
  import Secure from "../_components/Secure.svelte";
  import Nav from "./_components/Nav.svelte";
  import VerifyEmailMessage from "./_components/VerifyEmailMessage.svelte";
  import AwaitingAdditionalVerificationMessage from "./_components/AwaitingAdditionalVerificationMessage.svelte";

  import { appState } from "../../lib/appState.js";
  import { uiState } from "../../lib/uiState";
  import { goto } from "@sveltech/routify";

  let firebase = window.firebase;

  let tearingDown = false; // ensures graceful teardown of Svelte components, e.g. when logging off

  $: if ($appState.user && $appState.user.charity && !$appState.charity) {
    firebase
      .firestore()
      .collection("charities_v2")
      .doc($appState.user!.charity)
      .get()
      .then((doc) => {
        $appState.charity = doc.data() as Charity_v2;
      });
  }

  async function logoff() {

    try {
      tearingDown = true;

      let firebase = window.firebase;

      await firebase.auth().signOut();
      $appState.user = undefined;
      $appState.charity = undefined;
    }
    finally {
      tearingDown = false;
    }

    $goto('../..');
  }

  function adminView() {
    $goto('/admin');
  }

  function endAccess() {
    firebase
      .firestore()
      .collection("users_v1")
      .doc($appState.auth_user.email)
      .update({
        charity: firebase.firestore.FieldValue.delete()
      })
      .then(() => {
        try {
          tearingDown = true;
          $appState.user.charity = undefined;
          $appState.charity = undefined;
          $goto("/admin");
        }
        finally {
          tearingDown = false;
        }
      });
  }
</script>
